import { db } from "@/firebase";
import store from "@/store"

const UserService = {
	saveUserInfo() {
		db.collection("users").doc(store.state.currentUser.uid).get().then(doc => {
			if (doc.exists) {
				const oldData = doc.data();
				const device = this.getDeviceInfo();
				const data = {
					userId: store.state.currentUser.uid,
					datetimeLastVisit: new Date(),
					language: device.language
				};

				if (device.uuid) {
					if (oldData.devices === undefined) {
						data.devices = {};
						data.devices[device.uuid] = device;
					} else if (!(device.uuid in Object.keys(oldData.devices))) {
						data.devices = oldData.devices;
						data.devices[device.uuid] = device;
					}
				}

				db.collection("users").doc(store.state.currentUser.uid).update(data);
			} else {
				this.createUserInfo();
			}
		});
	},
	createUserInfo() {
		db.collection("users").doc(store.state.currentUser.uid).set({
			userId: store.state.currentUser.uid,
			datetimeCreated: new Date(),
			firstDevice: this.getDeviceInfo()
		}).then(() => {
			this.saveUserInfo();
		});
	},
	registrationUserInfo() {
		db.collection("users").doc(store.state.currentUser.uid).update({
			datetimeRegistration: new Date(),
			email: store.state.currentUser.email
		});
	},
	updateSongs() {
		db.collection("users").doc(store.state.currentUser.uid).update({
			songsCount: 4, // TODO: Tady dat pocet pisnicek
			songs: Object.keys(store.state.songs)
		});
	},
	getDeviceInfo() {
		const device = store.state.device;
		var d = {};

		Object.keys(device).map((key) => {
			if (device[key] !== undefined) {
				d[key] = device[key];
			}
		});

		return d;
	}
};


export {
	UserService
};
